import styles from "./LoadingDots.module.scss";

interface Props {
  color?: string;
}
const LoadingDots = ({ color }: Props) => {
  const { dotsContainer, dot } = styles;

  const dotStyle = { backgroundColor: color };

  return (
    <div data-testid="loading-dots" className={dotsContainer}>
      {Array.from({ length: 3 }).map((_, i) => (
        <div key={i} className={dot} style={dotStyle} />
      ))}
    </div>
  );
};

export default LoadingDots;
